import { CacheKey } from "@esignal/polygon-service-api";

export const CacheKey_truncRight = (entry: CacheKey): CacheKey => {
	const entryCopy: CacheKey = [...entry];
	while (entryCopy.length > 0 && !entryCopy[entryCopy.length - 1]) {
		entryCopy.pop();
	}
	return entryCopy;
};
